<template>
  <el-form
    ref="companyFormRef"
    :model="companyForm"
    :rules="rules"
    label-width="120px"
    class="mainSearch"
  >
  <el-alert title="请填写企业信息，提交审核后通过后，将开放平台核心功能。" type="error" v-if="companyForm.checkstatus==0"/>
  <el-alert title="您的企业信息正在审核中，请耐心等待。" type="warning" v-if="companyForm.checkstatus==1" />
  <el-alert title="您的企业信息已审核成功，平台核心功能已对您开放。" type="success" v-if="companyForm.checkstatus==2" />
  <el-alert title="您的企业信息审核未通过，请重新提交信息。" type="error" v-if="companyForm.checkstatus==3" />
  <el-alert title="完成企业认证 + 交纳平台会员费，解锁更多的功能和权限。" type="error" style="margin-top: 5px;"/>
  <el-divider />
  <h1>企业认证</h1>
    <el-form-item label="企业简称" prop="name">
      <el-input
        v-model.trim="companyForm.name"
        placeholder="请输入企业简称"
      ></el-input>
    </el-form-item>

    <el-form-item label="企业全称" prop="fullname">
      <el-input
        v-model="companyForm.fullname"
        placeholder="请输入企业全称"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="营业执照正面"
      prop="blicensefront"
    >
    <el-upload
      class="avatar-uploader"
      action="/api/common/upload"
      :disabled="companyForm.checkstatus==2?true:false"
      :show-file-list="false"
      :headers="headerUpload"
      :on-success="(response, file, item) => {handleSuccess(response, file, 'blicensefront')}"
      :before-upload="beforeUpload"
      name="file"
    >
      <img v-if="companyForm.blicensefront" :src="companyForm.blicensefront" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
    </el-form-item>

    <el-form-item
      label="营业执照反面"
      prop="blicenseback"
    >
    <el-upload
      class="avatar-uploader"
      action="/api/common/upload"
      :disabled="companyForm.checkstatus==2?true:false"
      :show-file-list="false"
      :headers="headerUpload"
      :on-success="(response, file, item) => {return handleSuccess(response, file, 'blicenseback')}"
      :before-upload="beforeUpload"
      name="file"
    >
      <img v-if="companyForm.blicenseback" :src="companyForm.blicenseback" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
    </el-form-item>

    <el-form-item label="统一信用代码" prop="taxid">
      <el-input
        v-model.trim="companyForm.taxid"
        placeholder="请输入统一信用代码"
      ></el-input>
    </el-form-item>
    <el-divider />
    <h1>法人信息</h1>
    <el-form-item label="联系人" prop="contact">
      <el-input
        v-model.trim="companyForm.contact"
        placeholder="请输入联系人"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="法人身份证正面"
      prop="idsfront"
    >
    <el-upload
      class="avatar-uploader"
      action="/api/common/upload"
      :disabled="companyForm.checkstatus==2?true:false"
      :show-file-list="false"
      :headers="headerUpload"
      :on-success="(response, file, item) => {return handleSuccess(response, file, 'idsfront')}"
      :before-upload="beforeUpload"
      name="file"
    >
      <img v-if="companyForm.idsfront" :src="companyForm.idsfront" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
    </el-form-item>

    <el-form-item
      label="法人身份证反面"
      prop="idsback"
    >
    <el-upload
      class="avatar-uploader"
      action="/api/common/upload"
      :disabled="companyForm.checkstatus==2?true:false"
      :show-file-list="false"
      :headers="headerUpload"
      :on-success="(response, file, item) => {return handleSuccess(response, file, 'idsback')}"
      :before-upload="beforeUpload"
      name="file"
    >
      <img v-if="companyForm.idsback" :src="companyForm.idsback" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
    </el-form-item>

    <el-form-item label="手机号" prop="phone">
      <el-input
        v-model.number="companyForm.phone"
        placeholder="请输入手机号"
      ></el-input>
    </el-form-item>

    <el-form-item label="邮箱" prop="email">
      <el-input
        v-model.trim="companyForm.email"
        placeholder="请输入邮箱"
      ></el-input>
    </el-form-item>

    <el-form-item label="微信号" prop="webchat">
      <el-input
        v-model.trim="companyForm.webchat"
        placeholder="请输入微信号"
      ></el-input>
    </el-form-item>

    <el-form-item label="QQ" prop="qq">
      <el-input
        v-model.number="companyForm.qq"
        placeholder="请输入QQ号"
      ></el-input>
    </el-form-item>

    <el-form-item label="联系地址" prop="address">
      <el-input
        v-model.trim="companyForm.address"
        placeholder="请输入联系地址"
      ></el-input>
    </el-form-item>
    <el-divider />
    <h1>银行账号</h1>
    <el-form-item label="银行名称" prop="bankname">
      <el-input
        v-model.trim="companyForm.bankname"
        placeholder="请输入银行名称"
      ></el-input>
    </el-form-item>

    <el-form-item label="银行账号" prop="bankaccount">
      <el-input
        v-model.trim="companyForm.bankaccount"
        placeholder="请输入银行账号"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="companyForm.checkstatus!=2">
        <el-button type="danger" :loading="loading" @click="doUserSave">{{
          loading ? "提交中 ..." : "提交企业信息"
        }}</el-button>
    </el-form-item>
  </el-form>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { saveCompany,getUserCompany } from "@/api/user";

import store from "@/store";

let timer;

const loading = ref(false);

let companyFormRef = ref();

//onMounted方法
onMounted(() => {

  //详情
  getUserCompany({  }).then((res) => {
      companyForm.value = res.data.extend.company
  });

});

//用户表单项
let companyForm = ref({
  userid: null,
  name:"",
  fullname: "",
  blicensefront: "",
  blicenseback: "",
  taxid: "",
  contact: "",
  idsfront: "",
  idsback: "",
  phone: "",
  email: "",
  webchat: "",
  qq: null,
  address: "",
  bankname: "",
  bankaccount: "",
});

const headerUpload = ref({
  Authorization: store.state.user.token,
});
const resultMsg = ref()
const beforeUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !=='image/jpg' && rawFile.type !=='image/png') {
    ElMessage.error('请上传JPG/JPEG/PNG图片格式!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('请上传小于2MB的图片!')
    return false
  }
  resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
  return true
}
const handleSuccess = (response, file, item) => {  
  if (response.code === 0) {
    ElMessage.error(response.msg)
  } else {
    resultMsg.value = response.url
    if (item == 'blicensefront') { companyForm.value.blicensefront = response.url}
    if (item == 'blicenseback') { companyForm.value.blicenseback = response.url}
    if (item == 'idsfront') { companyForm.value.idsfront = response.url}
    if (item == 'idsback') { companyForm.value.idsback = response.url}
  }
};

//注册用户数据
const doUserSave = () => {
  companyFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    saveCompany(companyForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
            ElMessage({
                message: res.data.msg,
                type: 'success'
            });
            clearTimeout(timer);
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//企业表单验证规则
const rules = ref({
  name: [
    { required: true, message: "企业简称不能为空", trigger: "blur" },
    { min: 2, max: 20, message: "企业简称字符长度在2~20之间", trigger: "blur" },
  ],
  fullname: [
    { required: true, message: "企业全称不能为空", trigger: "blur" },
    { min: 2, max: 100, message: "企业全称字符长度在2~100之间", trigger: "blur" },
  ],
  taxid: [
    { required: true, message: "统一信用代码不能为空", trigger: "blur" },
    { min: 18, max: 20, message: "统一信用代码字符长度在18~20之间", trigger: "blur" },
  ],
  contact: [
    { required: true, message: "联系人不能为空", trigger: "blur" },
    { min: 2, max: 6, message: "联系人字符长度在2~6之间", trigger: "blur" },
  ],
  phone: [
    { required: true, message: "手机号不能为空", trigger: "blur" },
    { pattern: /^1[3456789]\d{9}$/, message: "填写正确的手机号", trigger: "blur" },
  ],
  email: [
    { type: 'email', message: "正确填写邮箱格式", trigger: "blur" },
    { min: 5, max: 30, message: "邮箱号字符长度在5~30之间", trigger: "blur" },
  ],
  webchat: [
    { min: 5, max: 20, message: "微信号字符长度在5~20之间", trigger: "blur" },
  ],
  qq: [
    { type: 'number', message: "QQ号应该是数字", trigger: "blur",transform:(value)=>Number(value) },
  ],
  address: [
    { min: 5, max: 100, message: "地址字符长度在5~100之间", trigger: "blur" },
  ],
  bankname: [
    { min: 2, max: 50, message: "银行名称长度在2~50之间", trigger: "blur" },
  ],
  bankaccount: [
    { min: 15, max: 30, message: "银行账号长度在15~30之间", trigger: "blur" },
  ],
});
</script>

<style>
.avatar-uploader .avatar {
  width: 368px;
  height: 178px;
  display: block;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 368px;
  height: 178px;
  text-align: center;
}
</style>